/**
 * Sandbox document builder for the Agent scratchpad's free-form drawings.
 *
 * STATIC SVG ONLY — the d3 code-execution mode was removed 2026-08-14
 * (Nick: the model either uses the insight harness or draws something).
 * The SVG renders inside <iframe sandbox="allow-scripts-less"> — sandbox=""
 * with no allowances: no scripts, no same-origin, null origin. Safe by
 * construction; SMIL/CSS animations inside the SVG still play.
 *
 * Lives in a plain .js file deliberately: tag-text assembly confuses the
 * Vue SFC parser when inlined in a .vue file.
 */
const HEAD = '<!doctype html><meta charset="utf-8">'
  + '<style>body{margin:0;font-family:system-ui,sans-serif;background:#fff}'
  + 'svg{max-width:100%;height:auto;display:block}</style>'

export function drawingDoc(v) {
  return HEAD + (v.svg || '')
}

const SVG_OPEN = /<svg\b[^>]*>/i
const FILE_STYLE = '<style>svg{font-family:system-ui,sans-serif}</style>'

export function drawingFile(svg) {
  let text = String(svg || '').trim()
  if (!/^<svg\b/i.test(text)) text = text.slice(text.search(/<svg\b/i))
  const open = (text.match(SVG_OPEN) || [''])[0]
  if (!open) return ''
  let head = open
  if (!/\sxmlns=/.test(head)) head = head.replace(/^<svg\b/i, '<svg xmlns="http://www.w3.org/2000/svg"')
  return '<?xml version="1.0" encoding="UTF-8"?>\n' + text.replace(open, head + FILE_STYLE)
}

function drawingSize(svg) {
  const box = /viewBox\s*=\s*["']\s*[\d.-]+[\s,]+[\d.-]+[\s,]+([\d.]+)[\s,]+([\d.]+)/i.exec(svg)
  if (box) return { width: Number(box[1]), height: Number(box[2]) }
  const w = /<svg\b[^>]*\swidth\s*=\s*["']([\d.]+)/i.exec(svg)
  const h = /<svg\b[^>]*\sheight\s*=\s*["']([\d.]+)/i.exec(svg)
  return { width: w ? Number(w[1]) : 1280, height: h ? Number(h[1]) : 720 }
}

export function drawingPng(svg, minWidth = 1920) {
  const file = drawingFile(svg)
  const { width, height } = drawingSize(file)
  const scale = Math.max(1, minWidth / (width || minWidth))
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => {
      const canvas = document.createElement('canvas')
      canvas.width = Math.round(width * scale)
      canvas.height = Math.round(height * scale)
      const ctx = canvas.getContext('2d')
      ctx.fillStyle = '#fff'
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
      canvas.toBlob((blob) => (blob ? resolve(blob) : reject(new Error('PNG encoding failed'))), 'image/png')
    }
    img.onerror = () => reject(new Error('The drawing could not be rendered'))
    img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(file)
  })
}
